<template>
    <div>
        <section class="pt-8 pt-md-11">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                        <h1 class="display-4 text-center">
                            Genesis Blockchain Summit
                        </h1>
                        <p class="lead mb-7 text-center text-muted">
                            The Blockchain Summit in Kolkata, West Bengal, India.
                        </p>
                        <div class="row align-items-center py-5 border-top border-bottom">
                            <div class="col-6">
                                <time class="font-size-sm text-muted" datetime="2018-11-04">
                                    Published on April 13, 2018
                                </time>
                            </div>
                            <div class="col-6 text-right">
                                <span class="h6 text-uppercase text-muted d-none d-md-inline mr-4">
                                  Share:
                                </span>
                                <ul class="d-inline list-unstyled list-inline list-social">
                                    <li class="list-inline-item list-social-item mr-3">
                                        <a class="text-decoration-none" href="#!">
                                            <img alt="..." class="list-social-icon" src="../../../assets/img/icons/social/instagram.svg">
                                        </a>
                                    </li>
                                    <li class="list-inline-item list-social-item mr-3">
                                        <a class="text-decoration-none" href="#!">
                                            <img alt="..." class="list-social-icon" src="../../../assets/img/icons/social/facebook.svg">
                                        </a>
                                    </li>
                                    <li class="list-inline-item list-social-item mr-3">
                                        <a class="text-decoration-none" href="#!">
                                            <img alt="..." class="list-social-icon" src="../../../assets/img/icons/social/twitter.svg">
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="py-6 py-md-8">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                        <p>
                            Qlikchain participated in an Enlightening and Open discussion at Genesis Blockchain Summit organized by Department of IT&E, West Bengal, Kolkata about "How to build, survive and scale a pure Blockchain company". Interesting questions were put forth and emphasis was put on actual problem areas and ways to mitigate them.
                        </p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                        <div class="form-row mb-3">
                            <!-- Image -->
                            <a class="d-block mb-2 lift lift-lg" data-fancybox="gallery" data-height="563" data-width="750" href="/photos/events/genesis/genesis_cover.jpeg">
                                <img alt="..." class="img-fluid rounded" src="/photos/events/genesis/genesis_cover.jpeg">
                            </a>
                        </div>
                        <div class="form-row mb-3">
                            <div class="col-6">

                                <!-- Image -->
                                <a class="d-block mt-4 lift lift-lg" data-fancybox="gallery" data-height="563" data-width="750" href="/photos/events/genesis/genesis_2.jpeg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/events/genesis/genesis_2.jpeg">
                                </a>

                            </div>
                            <div class="col-6">

                                <!-- Image -->
                                <a class="d-block mt-4 lift lift-lg" data-fancybox="gallery" data-height="563" data-width="750" href="/photos/events/genesis/genesis_3.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/events/genesis/genesis_3.jpg">
                                </a>


                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "GenesisSummit"
    }
</script>

<style scoped>

</style>